/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RequestOriginEnum = 'SYSTEM' | 'OPERATOR';

export const RequestOriginEnum = {

    SYSTEM: 'SYSTEM' as RequestOriginEnum,

    OPERATOR: 'OPERATOR' as RequestOriginEnum
};

